import styled from 'styled-components'

const Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const TabMenus = styled.div`
  z-index: 99;
  display: flex;
  align-items: center;
  width: 100%;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.05);
  background: ${({ theme }) => theme.colors.white};
`

const TabButton = styled.div<{ active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing.verticalSpacingXL};
  padding-bottom: ${({ theme }) => theme.spacing.verticalSpacingS};
  transition: 0.2s;
  border-bottom: ${({ active, theme }) => `2px solid ${active ? theme.colors.primary : 'rgba(0,0,0,0)'}`};
`

export { Wrapper, TabMenus, TabButton }
